import { render, staticRenderFns } from "./TransportationPlann.vue?vue&type=template&id=1071bb9b&scoped=true&"
import script from "./TransportationPlann.vue?vue&type=script&lang=js&"
export * from "./TransportationPlann.vue?vue&type=script&lang=js&"
import style0 from "./TransportationPlann.vue?vue&type=style&index=0&id=1071bb9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071bb9b",
  null
  
)

export default component.exports